
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PageHeader, Card, Button, Input, Select } from '../../components/UI';
import { User, Globe } from '../../components/Icons';
import { useTranslation } from '../../contexts/LanguageContext';

const GeneralSettings: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const goBack = () => navigate('/dashboard');

  return (
    <div className="p-6 space-y-8 max-w-[1200px] mx-auto animate-in fade-in duration-500">
      <PageHeader 
        title={t('general_settings')} 
        breadcrumbs={[{ label: t('settings') }, { label: t('general_settings') }]} 
        onBack={goBack}
      />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        
        {/* Left Column: Profile Card */}
        <div className="md:col-span-1">
          <Card className="p-8 text-center flex flex-col items-center border-brand-light">
            <div className="w-24 h-24 rounded-full bg-[#00A3C4] flex items-center justify-center text-brand-dark font-black text-4xl shadow-md mb-6">
              DK
            </div>
            <h3 className="text-xl font-bold text-brand-dark dark:text-white mb-1">Daniel Kohler</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-6 font-medium">Platform Administrator</p>
            <Button size="sm" variant="primary" className="w-full mb-2">{t('change_avatar')}</Button>
            <Button size="sm" variant="ghost" className="w-full">{t('delete_photo')}</Button>
          </Card>
        </div>

        {/* Right Column: Settings Sections */}
        <div className="md:col-span-2 space-y-6">
          
          {/* Section: Profile Info */}
          <Card className="p-8 space-y-6">
            <div className="flex items-center gap-3 mb-2">
              <User className="text-brand-medium" size={20} />
              <h4 className="text-sm font-black uppercase tracking-widest text-brand-dark dark:text-white">{t('personal_information')}</h4>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="space-y-1.5">
                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 dark:text-brand-medium/60 ml-1">{t('first_name')}</label>
                <Input type="text" defaultValue="Daniel" />
              </div>
              <div className="space-y-1.5">
                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 dark:text-brand-medium/60 ml-1">{t('last_name')}</label>
                <Input type="text" defaultValue="Kohler" />
              </div>
              <div className="space-y-1.5 sm:col-span-2">
                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 dark:text-brand-medium/60 ml-1">{t('email_address')}</label>
                <Input type="email" defaultValue="d.kohler@io-market.com" />
              </div>
            </div>
          </Card>

          {/* Section: Regional & Language */}
          <Card className="p-8 space-y-6">
            <div className="flex items-center gap-3 mb-2">
              <Globe className="text-brand-medium" size={20} />
              <h4 className="text-sm font-black uppercase tracking-widest text-brand-dark dark:text-white">{t('interface_preferences')}</h4>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <Select label={t('language')} defaultValue="English (US)">
                <option className="dark:bg-brand-card-dark">English (US)</option>
                <option className="dark:bg-brand-card-dark">German (CH)</option>
                <option className="dark:bg-brand-card-dark">French (FR)</option>
              </Select>
              <Select label={t('timezone')} defaultValue="(GMT+01:00) Zurich">
                <option className="dark:bg-brand-card-dark">(GMT+01:00) Zurich</option>
                <option className="dark:bg-brand-card-dark">(GMT+00:00) London</option>
                <option className="dark:bg-brand-card-dark">(GMT-05:00) New York</option>
              </Select>
            </div>
          </Card>

          <div className="flex justify-end gap-3 pt-4">
             <Button variant="ghost">{t('discard_changes')}</Button>
             <Button variant="primary" className="px-10">{t('save_changes')}</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralSettings;
